import React from 'react'
import moment from 'moment'
import _ from 'underscore'
import { Badge } from '@/components/ui/badge'

class ScheduledCallsPartial extends React.Component {

  onClick = (e) => {
    e.preventDefault()

    const sales_enquiries = this.props.scheduled_call.sales_enquiries

    if (sales_enquiries.length > 0) {
      const sales_enquiry = sales_enquiries[0]

      if (sales_enquiry) {
        this.props.store.emit('enquiries:show', sales_enquiry.id)
      }
    }
    else {
      const sales_leads = this.props.scheduled_call.sales_leads

      if (sales_leads.length > 0) {
        const sales_lead = sales_leads[0]

        if (sales_lead) {
          this.props.store.emit('leads:show', sales_lead.id)
        }
      }
    }
  }

  render() {
    const scheduled_call = this.props.scheduled_call

    return (
      <a href="#" className="block px-4 py-3 text-muted-foreground no-underline transition-colors odd:bg-muted/30 hover:bg-muted/60" onClick={this.onClick}>
        <span className="flex items-baseline justify-between gap-2 text-sm font-semibold text-foreground">
          <span className="truncate">{scheduled_call.customer.name}</span>
          <small className="shrink-0 text-xs font-normal text-muted-foreground">{moment(scheduled_call.start_time).format('HH:mm')} - {moment(scheduled_call.end_time).format('HH:mm')}</small>
        </span>
        <span className="mt-0.5 flex items-center justify-between gap-2">
          <span className="flex flex-wrap gap-1">
            {_.map(scheduled_call.sales_enquiries, (sales_enquiry) => {
              return (
                <Badge key={sales_enquiry.id} variant="secondary">Enquiry {sales_enquiry.id}</Badge>
              )
            })}
            {_.map(scheduled_call.sales_leads, (sales_lead) => {
              return (
                <Badge key={sales_lead.id} variant="secondary">Lead {sales_lead.id}</Badge>
              )
            })}
          </span>
          <span className="truncate text-sm text-muted-foreground">{scheduled_call.name}</span>
        </span>
      </a>
    )
  }
}

export default ScheduledCallsPartial
